import { render, staticRenderFns } from "./RejectionSelection.vue?vue&type=template&id=55060e37"
import script from "./RejectionSelection.vue?vue&type=script&lang=js"
export * from "./RejectionSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports